// extracted by mini-css-extract-plugin
module.exports = {"yj-font-style":"yj-font-style--1la_E","yjInfinityLoadMore":"yjInfinityLoadMore--1v-pA","yjInfinityScrollText":"yjInfinityScrollText--24cLo"};